import { bankServices } from "../../config/axios";
import {
    CASHLIFTINGLIST_APPROVEREJECT_SUCCESS,
    CASHLIFTINGLIST_APPROVEREJECT_FAILED,
    RESET_CASHLIFTINGLIST_APPROVEREJECT,
    LOADING_CASHLIFTINGLIST_APPROVEREJECT,
    CASHLIFTINGLIST_APPROVEREJECT_NETWORKERROR,
} from '../types/index';

const resetbankCashLiftingApproveReject = () => {
    return { type: RESET_CASHLIFTINGLIST_APPROVEREJECT };
};

const bankCashLiftingApproveReject = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_CASHLIFTINGLIST_APPROVEREJECT });
    await bankServices
        .post("cashliftingapprovereject", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(success(res.data));
                    break;
                default:
                    dispatch(failed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: CASHLIFTINGLIST_APPROVEREJECT_NETWORKERROR,
                payload: err
            });
        });
}

function success(data) {
    return {
        type: CASHLIFTINGLIST_APPROVEREJECT_SUCCESS,
        payload: data
    };
}
function failed(data) {
    return {
        type: CASHLIFTINGLIST_APPROVEREJECT_FAILED,
        payload: data
    };
}

export { resetbankCashLiftingApproveReject, bankCashLiftingApproveReject }